import React, { useState, useEffect } from "react";
import { supabase } from "../utils/supabaseClient";
import LoadingSpinner from "./LoadingSpinner";
import "../styles/Industries.css";

const Industries = () => {
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchIndustries();
  }, []);

  const fetchIndustries = async () => {
    try {
      const { data, error } = await supabase
        .from("industries")
        .select("*")
        .order("title");

      if (error) throw error;
      setIndustries(data);
    } catch (err) {
      console.error("Error fetching industries:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner size="large" />;
  if (error)
    return (
      <div className="error-message">Error loading industries: {error}</div>
    );

  return (
    <section className="industries-section">
      <div className="industries-container">
        <div className="industries-header">
          <h2>Industries We Serve</h2>
          <p>Delivering excellence across diverse market sectors</p>
        </div>
        <div className="industries-grid">
          {industries.map((industry) => (
            <div key={industry.id} className="industry-card">
              <div className="industry-image-container">
                <img
                  src={industry.image_url}
                  alt={industry.title}
                  className="industry-image"
                />
                <div className="industry-overlay">
                  <p className="industry-description">{industry.tagline}</p>
                  {/* <button className="learn-more-btn">Learn More</button> */}
                </div>
              </div>
              <h3 className="industry-name">{industry.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
